import React from 'react';

import { Field, Text } from '@zapier/design-system';

import Link from 'app/common/components/Link';

import VersionModalWrapper from './VersionModalWrapper';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  date?: string;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSetDate: (value: string) => void;
  version: SemVer;
};

const toIsoDate = (d: Date) => d.toISOString().slice(0, 10);

const daysFromNow = (numDays: number) => {
  const d = new Date();
  d.setDate(d.getDate() + numDays);

  return toIsoDate(d);
};

const Deprecate = (props: Props) => {
  return (
    <VersionModalWrapper
      confirmButtonLabel="Deprecate"
      heading={`Deprecate Version ${props.version}`}
      isSaving={props.isSaving}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
    >
      <Text margin="10px 0px" tag="p">
        Deprecate unsupported integration versions to mark them as legacy in
        Zapier. Users with Zaps on these versions will receive email alerts and
        must transition to a newer version before the deprecation date, or their
        Zaps will pause.{' '}
        <Link
          href="https://docs.zapier.com/platform/publish/zap-templates#deprecating-versions-of-your-integration"
          target="_blank"
        >
          Update any Zap templates
        </Link>{' '}
        linked to deprecated versions. Use Deprecation mainly for versions with
        breaking changes. Otherwise, consider using Migrate to shift Zaps
        between versions. Only non-public versions can be deprecated, and an
        alternative version must be available for users.{' '}
        <Link
          href="https://docs.zapier.com/platform/manage/deprecate"
          target="_blank"
        >
          Learn more
        </Link>
        .
      </Text>
      <Text margin="10px 0px" tag="p">
        Select a deprecation date between 2 weeks and 1 year from today:
      </Text>
      <Text margin="20px 0px" tag="h3" type="Title">
        Select Date
      </Text>
      <Field
        label="Deprecation Date"
        renderInput={inputProps => (
          <input
            aria-label="Deprecation Date"
            max={daysFromNow(364)}
            min={daysFromNow(14)}
            onChange={event => props.onSetDate(event.target.value)}
            placeholder="dd/mm/yyyy" // Safari does not support type date
            type="date"
            value={props.date || ''}
            {...inputProps}
          />
        )}
      />
    </VersionModalWrapper>
  );
};

export default Deprecate;
